// extracted by mini-css-extract-plugin
export var breadcrumb = "_6-0";
export var breadcrumbArrow = "_6-1";